module.exports = __webpack_public_path__ + "img/10.2ad3c51c.png";